import { ApiRequestStatus, useFrontendStatus } from '@cmctechnology/webinvest-store-frontend';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { registerWebApiUnauthorised } from '@cmctechnology/webinvest-api-client-web-trading';
import { fetchClientDetails, fetchClientRoles, setForceLogout, signOut, unauthorise } from '../actions';
import { ApiRequest } from '../models/apiRequest';
import { CLIENT_STORE_NAME, IStore } from '../store';
import { createSelector } from '@reduxjs/toolkit';
import { logger } from '../utils';

const selectClientProfileSettingStatus = createSelector(
  (store: IStore) => store.frontend.apiResults.client?.status, // Input selector
  (value) => value
);

export const useAuthenticated = () => {
  const dispatch = useDispatch();
  const [finished, setFinished] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const { status: clientDetailsRequestStatus } = useFrontendStatus(CLIENT_STORE_NAME, ApiRequest.ClientDetailsGet1);
  const { status: clientRolesRequestStatus } = useFrontendStatus(CLIENT_STORE_NAME, ApiRequest.ClientRolesGet1);

  const clientProfileSettingStatus = useSelector(selectClientProfileSettingStatus);
  const authenticatedAt = useSelector((store: IStore) => store.client.session.authenticatedAt);
  const crc = useSelector((store: IStore) => store.client.crc);

  useEffect(() => {
    const unregister = registerWebApiUnauthorised(() => {
      setAuthenticated(false);
      if (crc) dispatch<any>(setForceLogout(true));
      dispatch<any>(unauthorise());
    });
    return () => unregister();
  }, []);

  useEffect(() => {
    if (authenticatedAt || crc) {
      if (!finished) setFinished(true);
      if (!authenticated) setAuthenticated(true);
      return;
    }

    if (!clientDetailsRequestStatus) {
      dispatch<any>(fetchClientDetails());
    }

    if (!clientRolesRequestStatus) {
      dispatch<any>(fetchClientRoles());
    }

    if (
      clientDetailsRequestStatus === ApiRequestStatus.Failed ||
      clientRolesRequestStatus === ApiRequestStatus.Failed ||
      clientProfileSettingStatus === ApiRequestStatus.Failed
    ) {
      logger.log(`from useAuthenticated: calling signOut`);
      logger.log(`from useAuthenticated: clientDetailsRequestStatus: ${clientDetailsRequestStatus}`);
      logger.log(`from useAuthenticated: clientRolesRequestStatus: ${clientRolesRequestStatus}`);
      logger.log(`from useAuthenticated: clientProfileSettingStatus: ${clientProfileSettingStatus}`);
      setFinished(true);
      setAuthenticated(false);
      dispatch<any>(signOut());

      return;
    }
  }, [authenticatedAt, crc, clientDetailsRequestStatus, clientRolesRequestStatus, clientProfileSettingStatus]);

  return { finished, authenticated };
};
